export default "__VITE_ASSET__eb704cdb__"